import {alignmentStatus, scorePill} from '../../../../../layouts/theme/designSystem';

export type WorkforceProfileHighlightVariant = 'strong' | 'partial';

export const getWorkforceProfileHighlightDotColor = (variant: WorkforceProfileHighlightVariant) =>
  variant === 'strong' ? alignmentStatus.metAccent : scorePill.medium.strokeColor;
